import { useApplicationProcess } from 'src/context/useJobDetails/useJobDetails';

export const useAllQuestions = () => {
  const { loading, error, data: applicationProcess } = useApplicationProcess();
  const questions = applicationProcess?.questionnaire?.questions || [];

  return {
    loading,
    error,
    data: questions,
  };
};
